import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'
import routes from '@/Router/routes.constants'

const useNewRMADrawer = ({ storeId, setToastInfo, navigation }) => {
  const [showNewRMADrawer, setShowNewRMADrawer] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [orders, setOrders] = useState(null)
  const { fetchData, loading } = useFetch(returnsServices.searchOrdersForRMA, { doInitialRequest: false })

  const openNewRMADrawer = () => {
    setShowNewRMADrawer(true)
  }

  const closeNewRMADrawer = () => {
    setShowNewRMADrawer(false)
    setOrders(null)
    setSearchValue('')
  }

  const onSearchOrders = async () => {
    try {
      if (searchValue) {
        const data = await fetchData({ storeId, query: searchValue })
        setOrders(data)
      }
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const onViewOrder = ({ orderName, customerEmail }) => {
    navigation(
      `${routes.transactionRMA}?orderName=${encodeURIComponent(orderName)}&customerEmail=${encodeURIComponent(customerEmail)}`
    )
  }

  return {
    showNewRMADrawer,
    openNewRMADrawer,
    closeNewRMADrawer,
    onSearchOrders,
    searchValue,
    setSearchValue,
    searchingOrders: loading,
    orders,
    onViewOrder,
  }
}

export default useNewRMADrawer
